import { AnalyticsStore } from '../../../../../common/js/stores/analytics.store';
import { IVideoSizes } from '../../../../../common/js/video-utils';

export class VideoSizesHandlerStrategy {
  analyticsStore: AnalyticsStore;

  constructor(analyticsStore: AnalyticsStore) {
    this.analyticsStore = analyticsStore;
  }

  reactToSizes(videoSizes: IVideoSizes): void {
    const {
      vast_video_height,
      vast_video_width,
      video_height,
      video_width
    } = videoSizes;

    // Do not check for discrepancies if one of the sizes is missing
    if (
      !vast_video_height ||
      !vast_video_width ||
      !video_height ||
      !video_width
    ) {
      return;
    }

    if (
      vast_video_height !== video_height ||
      vast_video_width !== video_width
    ) {
      this.analyticsStore.sendEvent('monitoring', 'sizes_discrepencies');
    }
  }
}
